import { render, staticRenderFns } from "./restore-tool.vue?vue&type=template&id=251ed5d6"
import script from "./restore-tool.vue?vue&type=script&lang=js"
export * from "./restore-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports